/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventQuestionStatus } from './EventQuestionStatus';
import {
    EventQuestionStatusFromJSON,
    EventQuestionStatusFromJSONTyped,
    EventQuestionStatusToJSON,
    EventQuestionStatusToJSONTyped,
} from './EventQuestionStatus';

/**
 * The administrators' view of a question: every field and who asked it.
 * @export
 * @interface EventQuestionRead
 */
export interface EventQuestionRead {
    /**
     * 
     * @type {string}
     * @memberof EventQuestionRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionRead
     */
    event_id: string;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionRead
     */
    asker_user_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionRead
     */
    competitor_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionRead
     */
    organization_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionRead
     */
    text: string;
    /**
     * 
     * @type {Date}
     * @memberof EventQuestionRead
     */
    created_at: Date;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionRead
     */
    answer_text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionRead
     */
    answered_by?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EventQuestionRead
     */
    answered_at?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionRead
     */
    published_text?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EventQuestionRead
     */
    published_at?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionRead
     */
    asker_username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionRead
     */
    asker_label?: string | null;
    /**
     * 
     * @type {EventQuestionStatus}
     * @memberof EventQuestionRead
     */
    status: EventQuestionStatus;
}



/**
 * Check if a given object implements the EventQuestionRead interface.
 */
export function instanceOfEventQuestionRead(value: object): value is EventQuestionRead {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('event_id' in value) || value['event_id'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function EventQuestionReadFromJSON(json: any): EventQuestionRead {
    return EventQuestionReadFromJSONTyped(json, false);
}

export function EventQuestionReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventQuestionRead {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'event_id': json['event_id'],
        'asker_user_id': json['asker_user_id'] == null ? undefined : json['asker_user_id'],
        'competitor_id': json['competitor_id'] == null ? undefined : json['competitor_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'text': json['text'],
        'created_at': (new Date(json['created_at'])),
        'answer_text': json['answer_text'] == null ? undefined : json['answer_text'],
        'answered_by': json['answered_by'] == null ? undefined : json['answered_by'],
        'answered_at': json['answered_at'] == null ? undefined : (new Date(json['answered_at'])),
        'published_text': json['published_text'] == null ? undefined : json['published_text'],
        'published_at': json['published_at'] == null ? undefined : (new Date(json['published_at'])),
        'asker_username': json['asker_username'] == null ? undefined : json['asker_username'],
        'asker_label': json['asker_label'] == null ? undefined : json['asker_label'],
        'status': EventQuestionStatusFromJSON(json['status']),
    };
}

export function EventQuestionReadToJSON(json: any): EventQuestionRead {
    return EventQuestionReadToJSONTyped(json, false);
}

export function EventQuestionReadToJSONTyped(value?: EventQuestionRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'event_id': value['event_id'],
        'asker_user_id': value['asker_user_id'],
        'competitor_id': value['competitor_id'],
        'organization_id': value['organization_id'],
        'text': value['text'],
        'created_at': ((value['created_at']).toISOString()),
        'answer_text': value['answer_text'],
        'answered_by': value['answered_by'],
        'answered_at': value['answered_at'] == null ? undefined : ((value['answered_at'] as any).toISOString()),
        'published_text': value['published_text'],
        'published_at': value['published_at'] == null ? undefined : ((value['published_at'] as any).toISOString()),
        'asker_username': value['asker_username'],
        'asker_label': value['asker_label'],
        'status': EventQuestionStatusToJSON(value['status']),
    };
}

